export const OCEANARIUM_SHOW = 'OceanariumShow'

export const CALENDAR_EVENT = 'CalendarEvent'

export const PROD_CALENDAR_EVENT = 'ProductionCalendarEvent'

export const SCHEDULE_ACTIVITY = 'ScheduleActivity'
